export const SELECTED_LOOP_STORAGE_KEY = 'nexus-selected-loop-id';
export const LAST_LOOP_ROUTE_STORAGE_KEY = 'nexus-last-loop-route';
